import React, {useEffect, useState} from 'react';
import ColorPicker from './ColorPicker';
import {useTranslation} from "react-i18next";
import {Sortable, Input, Button} from "uikit";
import {generateHash} from "@/utils/generateHash";
import DragIcon from "@/assets/images/icons/16/arrows-v.svg";
import EditIcon from "@/assets/images/icons/16/pencil.svg";
import SbpIcon from "@/assets/images/icons/16/sbp_button.svg";

const RegistrationColor = ({data, sortable, handlers}) => {
    const {handlerCreateButtons, handlerDelete} = handlers;
    const {t} = useTranslation('common')
    const [fields, setFields] = useState([]);

    useEffect(() => {
        matchColorServerData(data)
    }, [data]);

    const matchColorServerData = (data) => {
        setFields(() => data ? data
            .sort((a, b) => a.pos - b.pos)
            .map(button => ({
                hash: generateHash(),
                isEdit: false,
                isOpened: false,
                id: button.id,
                position: button.pos,
                type_id: button.type_id,
                background_color: button.background_color,
                title: button.title,
                name: button.name,
                box_shadow_color: button.box_shadow_color,
                font_color: button.font_color,
                content: button.content,
                isBoxShadowPickerOpen: false,
                isBGPickerOpen: false,
                isFontColorPickerOpen: false
            })) : []);
    };

    const setData = (value, hash, field) => {
        let isEdit = (field !== 'isOpened');
        setFields(fields => fields.map((item) => {
            if (item.hash === hash) {
                return {
                    ...item,
                    [field]: value,
                    isEdit: isEdit,
                };
            }
            return item;
        }));
    };

    const handleSave = (field) => {
        handlerCreateButtons([field]);
    };

    const onSortEnd = async (updated) => {
        const updatedFields = updated.map((field, index) => ({
            ...field,
            isEdit: true,
            position: index + 1,
        }));
        setFields(updatedFields);
        handlerCreateButtons(updatedFields);
    };

    return (
        <div className={'paymentsList'}>
            <Sortable data={fields} onChange={onSortEnd}>
                {fields.map((field, field_idx) => {
                    const isDisabled = fields.some(f => f.isOpened && f.hash !== field.hash);

                    return (
                        <div key={field_idx}>
                            <div className={'item'}>
                                <div className={'label'}>
                                    <h3>{t(field.type_id)}</h3>
                                    <div className={'actionsXs'}>
                                        <Button
                                            size="small"
                                            type="secondary"
                                            theme="ghost"
                                            disabled={isDisabled}
                                            onClick={() => setData(true, field.hash, "isOpened")}>
                                            <EditIcon/>
                                        </Button>

                                        {sortable && <Sortable.DragHandle key={field_idx}>
                                            <Button
                                                size="small"
                                                type="secondary"
                                                theme="ghost"
                                                disabled={isDisabled}
                                                onClick={() => null}>
                                                <DragIcon/>
                                            </Button>
                                        </Sortable.DragHandle>}
                                    </div>
                                </div>
                                <div className={'previewActions'}>
                                    <div className={'preview'}>
                                        <Button
                                            size="small"
                                            style={{
                                                "backgroundColor": field.background_color,
                                                color: field.font_color,
                                                ...(field.box_shadow_color !== "" ? {boxShadow: `${field.box_shadow_color} 0px 0px 0px 2px inset`} : {}),
                                            }}
                                            onClick={() => setData(true, field.hash, "isOpened")}>
                                            {field.name}
                                            {field.type_id === 'sbp' && <SbpIcon/>}
                                        </Button>
                                    </div>
                                    <div className={'actions'}>
                                        <Button
                                            size="small"
                                            type="secondary"
                                            theme="ghost"
                                            disabled={isDisabled}
                                            onClick={() => setData(true, field.hash, "isOpened")}>
                                            <EditIcon/>
                                        </Button>

                                        {sortable && <Sortable.DragHandle key={field_idx}>
                                            <Button
                                                size="small"
                                                type="secondary"
                                                theme="ghost"
                                                disabled={isDisabled}
                                                onClick={() => null}>
                                                <DragIcon/>
                                            </Button>
                                        </Sortable.DragHandle>}
                                    </div>
                                </div>
                            </div>
                            {field.isOpened && <div className={'editor'}>
                                <div key={field_idx} className={"colors__reg"}>
                                    <div className={"colors__settings"}>
                                        <div className={"colors__form"}>
                                            <Input
                                                size={'small'}
                                                value={field.name}
                                                maxLength={20}
                                                onChange={(e) => setData(e.target.value, field.hash, "name")}
                                                label={'Текст'}
                                            />
                                        </div>

                                        <div className={"colors__picker"}>
                                            <div className={'colors__text'}>Фон</div>
                                            <div
                                                onClick={() => setData(true, field.hash, "isBGPickerOpen")}
                                                style={{"backgroundColor": field.background_color}}
                                                className={"colors__color-btn"}
                                            />
                                            <div className={"colors__palette"}>
                                                {field.isBGPickerOpen ? <ColorPicker
                                                        closeOnBlur={() => setData(false, field.hash, "isBGPickerOpen")}
                                                        color={field.background_color ? field.background_color : "#d9d9d9"}
                                                        onChange={(value) => setData(value.hex, field.hash, "background_color")}
                                                        onDelete={false}
                                                    />
                                                    : null}
                                            </div>
                                        </div>
                                        <div className={"colors__picker"}>
                                            <div className={'colors__text'}>Рамка</div>
                                            <div
                                                onClick={() => setData(true, field.hash, "isBoxShadowPickerOpen")}
                                                style={{"backgroundColor": field.box_shadow_color}}
                                                className={`colors__color-btn ${!field.box_shadow_color ? "none" : ""}`}
                                            />
                                            <div className={"colors__palette"}>
                                                {field.isBoxShadowPickerOpen ? <ColorPicker
                                                    closeOnBlur={() => setData(false, field.hash, "isBoxShadowPickerOpen")}
                                                    color={field.box_shadow_color ? field.box_shadow_color : "#d9d9d9"}
                                                    onChange={(value) => setData(value.hex, field.hash, "box_shadow_color")}
                                                    onDelete={() => setData("", field.hash, "box_shadow_color")}
                                                /> : null}
                                            </div>
                                        </div>
                                        <div className={"colors__picker"}>
                                            <div className={'colors__text'}>Текст</div>
                                            <div
                                                onClick={() => setData(true, field.hash, "isFontColorPickerOpen")}
                                                style={{"backgroundColor": field.font_color}}
                                                className={"colors__color-btn"}
                                            />
                                            <div className={"colors__palette"}>
                                                {field.isFontColorPickerOpen ? <ColorPicker
                                                    closeOnBlur={() => setData(false, field.hash, "isFontColorPickerOpen")}
                                                    color={field.font_color ? field.font_color : "#d9d9d9"}
                                                    onChange={(value) => setData(value.hex, field.hash, "font_color")}
                                                    onDelete={false}
                                                /> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"bottomActions"}>

                                    <Button
                                        size="small"
                                        type="tertiary"
                                        theme="default"
                                        disabled={!field.id}
                                        onClick={() => handlerDelete(field)}>
                                        Cтили по умолчанию
                                    </Button>

                                    <div className={'save'}>
                                        <Button
                                            size="small"
                                            type="tertiary"
                                            theme="ghost"
                                            onClick={() => setData(false, field.hash, "isOpened")}>
                                            Отмена
                                        </Button>
                                        <Button
                                            size="small"
                                            type="primary"
                                            theme="default"
                                            disabled={!field.isEdit}
                                            onClick={() => handleSave(field)}>
                                            Сохранить
                                        </Button>
                                    </div>
                                </div>

                            </div>}
                        </div>
                    );
                })}
            </Sortable>
        </div>
    );
}

export default RegistrationColor;
